export function genButtonBounds(index) {
  const x = -(70 * 1.5) + (index % 4) * 70;
  const y = 0 + (index < 4 ? 0 : 70);
  return { x, y, width: 64, height: 64 };
}